import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/core/auth.service';
import { environment } from '../../../environments/environment';

/**
 * AUTH INTERCEPTOR
 * Intercepts requests to add Bearer token.
 * Traps 401 Unauthorized responses to trigger token refresh queue flow.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const base = new URL(environment.apiUrl);
  const target = new URL(req.url, base);
  const basePath = base.pathname.replace(/\/$/, '');
  if (target.origin !== base.origin || !(target.pathname === basePath || target.pathname.startsWith(basePath + '/'))) {
    return next(req);
  }
  // Do not attach token to public endpoints that may fail preflight (CORS) with Auth headers
  const isPublicPath =
    req.url.includes('/Auth/login') ||
    req.url.includes('/Auth/refresh-token') ||
    req.url.includes('/Auth/forgot-password') ||
    req.url.includes('/healthz') ||
    req.url.includes('/master') ||
    req.url.includes('/Catalog');

  if (isPublicPath) {
    return next(req);
  }

  const authService = inject(AuthService);
  const token = authService.getToken();

  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Return Observable via handle401Error utilizing rxjs switchMap internally
        return authService.handle401Error(req, next);
      }
      return throwError(() => error);
    }),
  );
};
